import { useState } from 'react';
import {useNavigate} from 'react-router-dom';
import {PATH_DASHBOARD} from '../../../routes/paths';
// @mui
import { styled } from '@mui/material/styles';
import { Input, Slide, Button, InputAdornment, ClickAwayListener } from '@mui/material';
// utils
import cssStyles from '../../../utils/cssStyles';
// components
import Iconify from '../../../components/Iconify';
import { IconButtonAnimate } from '../../../components/animate';

// ----------------------------------------------------------------------

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const SearchbarStyle = styled('div')(({ theme }) => ({
  ...cssStyles(theme).bgBlur(),
  top: 0,
  left: 0,
  zIndex: 99,
  width: '100%',
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  height: APPBAR_MOBILE,
  padding: theme.spacing(0, 3),
  boxShadow: theme.customShadows.z8,
  [theme.breakpoints.up('md')]: {
    height: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

export default function Searchbar() {
  const [isOpen, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    if (!query.trim()) return;
    navigate(`${PATH_DASHBOARD.leads.list}?search=${encodeURIComponent(query.trim())}`);
    handleClose();
  };

  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div>
        {!isOpen && (
          <IconButtonAnimate aria-label="Buscar" onClick={handleOpen}>
            <Iconify icon={'eva:search-fill'} width={20} height={20} />
          </IconButtonAnimate>
        )}

        <Slide direction="down" in={isOpen} mountOnEnter unmountOnExit>
          <SearchbarStyle as="form" onSubmit={handleSearch} onKeyDown={event => {if (event.key === 'Escape') handleClose();}}>
            <Input
              autoFocus
              fullWidth
              disableUnderline
              placeholder="Buscar empresas por nome ou CNPJ"
              inputProps={{'aria-label': 'Buscar empresas por nome ou CNPJ'}}
              value={query}
              onChange={event => setQuery(event.target.value)}
              startAdornment={
                <InputAdornment position="start">
                  <Iconify
                    icon={'eva:search-fill'}
                    sx={{ color: 'text.disabled', width: 20, height: 20 }}
                  />
                </InputAdornment>
              }
              sx={{ mr: 1, fontWeight: 'fontWeightBold' }}
            />
            <Button type="submit" variant="contained" disabled={!query.trim()}>
              Buscar
            </Button>
            <IconButtonAnimate aria-label="Fechar busca" onClick={handleClose} sx={{ml: 1}}>
              <Iconify icon="eva:close-fill" width={20}/>
            </IconButtonAnimate>
          </SearchbarStyle>
        </Slide>
      </div>
    </ClickAwayListener>
  );
}
